// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.TourActionType

export enum TourActionType {
  IRENE_CANCEL = 'IRENE_CANCEL',
  IRENE_CONFIRM = 'IRENE_CONFIRM',
  IRENE_DECLINE = 'IRENE_DECLINE',
  RACHEL_CANCEL = 'RACHEL_CANCEL',
  SYSTEM_AUTO_DECLINE = 'SYSTEM_AUTO_DECLINE',
}

export const TourActionType_values = [
  TourActionType.IRENE_CANCEL,
  TourActionType.IRENE_CONFIRM,
  TourActionType.IRENE_DECLINE,
  TourActionType.RACHEL_CANCEL,
  TourActionType.SYSTEM_AUTO_DECLINE,
] as const;
